import { defineStore } from "pinia";
import { setCssVar } from "@/utils/themed.js";

export const useThemeStore = defineStore("theme", {
  state: () => ({
    fontSizeType: "default", // 默认字体大小
    elementPlusCom_size: "large", // 饿了么组件大小
    fontSizeMap: {
      small: "0.729167vw",
      default: "0.833333vw",
      large: "0.9375vw",
    },
  }),
  getters: {
    fontSize() {
      return this.fontSizeMap[this.fontSizeType];
    },
  },
  actions: {
    setFontSize(size = "default") {
      this.fontSizeType = size;
      setCssVar("--el-font-size-base", this.fontSize);
      // setCssVar(
      //   "--font-size",
      //   "40px",
      //   document.querySelector(".el-form-item--small"),
      // );
    },
    setElementPlusCom_size(size) {
      // this.elementPlusCom_size = size;
    },
  },
});
